import { FC } from 'react';
import { Switch } from '@app/form_components';
import { UseObjectFormObject, useObjectForm } from '@app/hooks';
import {
  ValueOrVariableAutocomplete,
  VariableAutocomplete
} from '@app/page-components/shared';
import { OasysObjectConfig, VariableType } from '@app/types';
import { NodeFooter } from './NodeFooter';
import { NodeHeader } from './NodeHeader';

export type OasysNodeModelFormProps = {
  object: UseObjectFormObject<OasysObjectConfig>;
};

export const OasysNodeModelForm: FC<OasysNodeModelFormProps> = ({
  object
}) => {
  const labels = window.l.property;
  const { createSubmitHandler, getControlProps } = useObjectForm({ object });

  return (
    <form key="form" className="flex-column flex-gap" onSubmit={createSubmitHandler()}>
      <NodeHeader getControlProps={getControlProps} />
      <ValueOrVariableAutocomplete
        {...getControlProps('domain')}
        label="Domain"
        tooltip="OASYS task name."
        valueType={VariableType.string}
      />
      <VariableAutocomplete
        {...getControlProps('transcript')}
        label="Transcript"
        tooltip="The transcript that is pushed to OASYS"
      />
      <ValueOrVariableAutocomplete
        {...getControlProps('autoStartUp')}
        label="Auto Start Up"
        tooltip="Have OASYS say (true) or skip (false) its start up prompt"
        valueType={VariableType.boolean}
      />
      <Switch
        {...getControlProps('sensitiveData')}
        label="Sensitive Data"
      />
      <VariableAutocomplete
        {...getControlProps('transientVariables')}
        label="Transient Variables"
        tooltip="Key/value map of OASYS transient variables."
      />
      <VariableAutocomplete
        {...getControlProps('conversationVariables')}
        label="Conversation Variables"
        tooltip="Key/value map of OASYS conversation variables."
      />
      <VariableAutocomplete
        {...getControlProps('firstName')}
        label="First Name"
        tooltip={labels.oasysPersonalizationTooltip}
      />
      <VariableAutocomplete
        {...getControlProps('lastName')}
        label="Last Name"
        tooltip={labels.oasysPersonalizationTooltip}
      />
      <NodeFooter getControlProps={getControlProps} />
    </form>
  );
};
